import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { TModalCloseEvent } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { TvChannelComparison } from '@teliaee/telia-common-components';
import config from '../Config';
import LanguageStore from '../stores/LanguageStore';

export interface TvChannelComparisonContainerProps {
  isOpen?: boolean;
  headingText?: string;
  headingLevel?: number;
  languageStore?: LanguageStore;
  isModal?: boolean;
  onClose?: (event: TModalCloseEvent) => void;
  defaultSelectedPackage?: string;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
}

@observer
class TvChannelComparisonContainer extends React.Component<TvChannelComparisonContainerProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    return (
      <TvChannelComparison
        defaultSelectedPackage={this.props.defaultSelectedPackage}
        isOpen={this.props.isOpen}
        headingText={this.props.headingText}
        headingLevel={this.props.headingLevel}
        tier={config.componentTier}
        language={this.props.languageStore.currentLanguage}
        isModal={this.props.isModal}
        onClose={this.props.onClose}
      />
    );
  }
}

export default inject('languageStore')(TvChannelComparisonContainer);
